/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * Checkout APIs
 */

import externalCartAddToCart from './externalCartAddToCart';
import externalCartDeleteItem from './externalCartDeleteItem';
import externalCartUpdateDTW from './externalCartUpdateDTW';
import getCatalogSelect from './getCatalogSelect';
import getExternalCartDTW from './getExternalCartDTW';
import getExternalCartToken from './getExternalCartToken';
import externalCartUpdateTip from './externalCartUpdateTip';

const externalCartClient = {
    externalCartAddToCart,
    externalCartDeleteItem,
    externalCartUpdateDTW,
    externalCartUpdateTip,
    getCatalogSelect,
    getExternalCartDTW,
    getExternalCartToken,
};

export default externalCartClient;
